var CLOSEST_DIV_URL, ClosestDivision;

CLOSEST_DIV_URL = '/layout/get_location_sort?callback=?';

module.exports = ClosestDivision = {
  getClosestDivision: function(options) {
    var error, lang, lat, lng, loc, locale, ref, success;
    if (options == null) {
      options = {};
    }
    loc = options.loc, lat = options.lat, lng = options.lng, success = options.success, error = options.error;
    lang = document.head.getAttribute('data-language');
    locale = document.head.getAttribute('data-locale');
    if ((ref = this._xhr) != null) {
      ref.abort();
    }
    this._xhr = $.getJSON(CLOSEST_DIV_URL, {
      loc: loc,
      lat: lat,
      lng: lng,
      lang: lang,
      locale: locale
    }, success);
    return this._xhr.fail(error);
  },
  abort: function() {
    var ref;
    return (ref = this._xhr) != null ? ref.abort() : void 0;
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL3NlYXJjaC9jb21tb24vbV9jbG9zZXN0X2RpdmlzaW9uLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9zZWFyY2gvY29tbW9uL21fY2xvc2VzdF9kaXZpc2lvbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxlQUFBLEdBQWtCOztBQUdsQixNQUFNLENBQUMsT0FBUCxHQUFpQixlQUFBLEdBQ2Y7RUFBQSxrQkFBQSxFQUFvQixTQUFDLE9BQUQ7QUFDbEIsUUFBQTs7TUFEbUIsVUFBVTs7SUFDNUIsaUJBQUQsRUFBTSxpQkFBTixFQUFXLGlCQUFYLEVBQWdCLHlCQUFoQixFQUF5QjtJQUV6QixJQUFBLEdBQVMsUUFBUSxDQUFDLElBQUksQ0FBQyxZQUFkLENBQTJCLGVBQTNCO0lBQ1QsTUFBQSxHQUFTLFFBQVEsQ0FBQyxJQUFJLENBQUMsWUFBZCxDQUEyQixhQUEzQjs7U0FFSixDQUFFLEtBQVAsQ0FBQTs7SUFDQSxJQUFDLENBQUEsSUFBRCxHQUFRLENBQUMsQ0FBQyxPQUFGLENBQVUsZUFBVixFQUEyQjtNQUFDLEtBQUEsR0FBRDtNQUFNLEtBQUEsR0FBTjtNQUFXLEtBQUEsR0FBWDtNQUFnQixNQUFBLElBQWhCO01BQXNCLFFBQUEsTUFBdEI7S0FBM0IsRUFBMEQsT0FBMUQ7V0FDUixJQUFDLENBQUEsSUFBSSxDQUFDLElBQU4sQ0FBVyxLQUFYO0VBUmtCLENBQXBCO0VBVUEsS0FBQSxFQUFPLFNBQUE7QUFDTCxRQUFBOzBDQUFLLENBQUUsS0FBUCxDQUFBO0VBREssQ0FWUCJ9
